/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1237
 */

var r = require(/* 271 */"../271")
var o = require(/* 168 */"../168")
var i = require(/* 1078 */"../../1783/1093/1078")
module.exports = !r && !o(function () {
  return 7 != Object.defineProperty(i("div"), "a", {
    get: function () {
      return 7
    }
  }).a
})
